import page1 from './themes/page1.js'
import page2 from './themes/page2.js'
export default {
  page1,
  page2,
}